export default function Hero() {
  const scrollToForm = () => {
    const element = document.getElementById('lead-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/dfeffc8ea1928ebe43dbaf3356100f21.jpg"
          alt="Professional Handyman Services"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Your Trusted <strong>Handyman</strong> in <strong>Stillwater</strong>
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-10 max-w-3xl mx-auto leading-relaxed">
          Professional home repair and improvement services across Stillwater, Enid, Ponca City, and surrounding areas. Quality workmanship you can count on.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={scrollToForm}
            className="bg-teal-600 text-white px-10 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Request a Quote
          </button>
          <a 
            href="tel:4057476904"
            className="bg-white text-gray-900 px-10 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap flex items-center gap-3"
          >
            <i className="ri-phone-line text-xl"></i>
            Call 405-747-6904
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/80"></i>
      </div>
    </section>
  );
}